import { Role } from '@/core/components/auth/auth.types'
import { ErrorComponent } from '@/core/components/ErrorComponent'
import { LoadingList } from '@/core/components/LoadingList'
import { addOnsQueryOptions } from '@/core/components/sites/site/rooms/add-ons/addOnsQueryOptions'
import { roomsQueryOptions } from '@/core/components/sites/site/rooms/roomQueryOptions'
import { cancellationPoliciesQueryOptions } from '@/core/components/sites/site/site-customization/policies/policiesQueryOptions'
import { taxAndFeesPoliciesQueryOptions } from '@/core/components/sites/site/site-customization/policies/taxAndFeesQueryOptions'
import { defer } from '@tanstack/react-router'
import { redirect } from '@tanstack/react-router'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/_layout/dashboard/sites/$siteId/rates-and-packages/rates/create/'
)({
  beforeLoad: ({ context: { auth } }) => {
    if (auth.isExpired()) {
      return
    }
    if (!auth.isAuthenticated) {
      throw redirect({
        to: '/',
      })
    }
    if (auth.user?.role === Role['Front-Desk']) {
      throw redirect({
        to: '/dashboard',
      })
    }
  },
  loader: ({ context: { queryClient, auth }, params: { siteId } }) => {
    const rooms = defer(
      queryClient.ensureQueryData(roomsQueryOptions(siteId, auth.token!))
    )
    const addOns = defer(
      queryClient.ensureQueryData(addOnsQueryOptions(siteId, auth.token!))
    )
    const taxes = defer(
      queryClient.ensureQueryData(taxAndFeesPoliciesQueryOptions(siteId, auth.token!))
    )
    const cancelation = defer(
      queryClient.ensureQueryData(cancellationPoliciesQueryOptions(siteId, auth.token!))
    )

    return {
      rooms,
      addOns,
      taxes,
      cancelation,
    }
  },
  pendingComponent: LoadingList,
  errorComponent: ErrorComponent,
})
